import { screens } from './tailwind';

const minWidth = (breakpoint: string): string => `(min-width: ${breakpoint})`;

const maxWidth = (breakpoint: string): string =>
  `(max-width: ${parseInt(breakpoint.replace('px', '')) - 1}px)`;

const widthRange = (minBreakpoint: string, maxBreakpoint: string): string =>
  `${minWidth(minBreakpoint)} and ${maxWidth(maxBreakpoint)}`;

export type Breakpoints = keyof typeof screens | 'xs';

export type BreakpointObjectType = {
  [key in Breakpoints]?: string;
};
export const ScreenSizesMinimums: Required<BreakpointObjectType> = {
  ...screens,
  xs: '0px'
};

type ScreenSizeQueriesBreakpoints =
  | Breakpoints
  | `${Exclude<Breakpoints, '2xl'>}Only`
  | `below${Capitalize<Exclude<Breakpoints, 'xs'>>}`
  | 'smLowerEndOnly';

type ScreenSizeQueriesType = {
  [key in ScreenSizeQueriesBreakpoints]: string;
};

export const ScreenSizeQueries = {
  xs: minWidth('0px'),
  xsOnly: maxWidth(screens.sm),

  smLowerEndOnly: maxWidth(screens.sm728),
  sm: minWidth(screens.sm),
  belowSm: maxWidth(screens.sm),
  smOnly: widthRange(screens.sm, screens.md),

  sm700: minWidth(screens.sm700),
  belowSm700: maxWidth(screens.sm700),
  sm700Only: widthRange(screens.sm700, screens.sm728),

  sm728: minWidth(screens.sm728),
  belowSm728: maxWidth(screens.sm728),
  sm728Only: widthRange(screens.sm728, screens.md),

  md: minWidth(screens.md),
  belowMd: maxWidth(screens.md),
  mdOnly: widthRange(screens.md, screens.lg),

  belowMd1049: maxWidth(screens.md1049),
  md1049: minWidth(screens.md1049),
  md1049Only: widthRange(screens.md1049, screens.lg),

  lg: minWidth(screens.lg),
  belowLg: maxWidth(screens.lg),
  lgOnly: widthRange(screens.lg, screens.xl),

  xl: minWidth(screens.xl),
  belowXl: maxWidth(screens.xl),
  xlOnly: widthRange(screens.xl, screens['2xl']),

  '2xl': minWidth(screens['2xl']),
  below2xl: maxWidth(screens['2xl'])
} satisfies ScreenSizeQueriesType;

/** breakpoints sorted descending */
export const breakpoints: Breakpoints[] = (
  Object.keys(ScreenSizesMinimums) as Breakpoints[]
).toSorted((a, b) => {
  const aSize = ScreenSizesMinimums[a];
  const bSize = ScreenSizesMinimums[b];
  return parseInt(bSize) - parseInt(aSize);
});
